module.exports = __webpack_public_path__ + "img/P_FAQ01.8a0fa4f6.png";